














































import {
  defineComponent, PropType, computed, ref, watch, toRefs,
} from '@nuxtjs/composition-api';
import { SfAccordion, SfTable } from '@storefront-ui/vue';
import { Product } from '~/modules/catalog/product/types';
import type { Country } from '~/modules/GraphQL/types';
import { useCountrySearch } from '~/composables/useCountrySearch';
import {
  getProductMaterial,
  getProductWeightCapacity,
  getProductWarrantyNote,
  getProductClimbingDetails,
  getProductCountryOfManufacture,
  getProductSplitDetails,
} from '~/modules/catalog/product/getters/productGetters';
import SvgImage from '~/components/General/SvgImage.vue';
import { useProductStore } from '~/modules/catalog/stores/product';

export default defineComponent({
  components: {
    SfAccordion,
    SfTable,
    SvgImage,
  },
  props: {
    product: {
      type: [Object, null] as PropType<Product | null>,
      default: null,
    },
    tab: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { lastOpenedTabId, resetLastOpenedTabId } = toRefs(useProductStore());

    const country = ref<Country>();
    const { search: searchCountry } = useCountrySearch();

    const countryCode = computed(() => getProductCountryOfManufacture(props.product));
    const attributes = computed(() => [
      {
        label: 'Material',
        value: getProductMaterial(props.product),
      }, {
        label: 'Weight capacity',
        value: getProductWeightCapacity(props.product),
      }, {
        label: 'Warranty Note',
        value: getProductWarrantyNote(props.product),
      }, {
        label: 'Climbing',
        value: getProductClimbingDetails(props.product),
      }, {
        label: 'Country of Manufacture',
        value: country.value?.full_name_locale || countryCode.value,
      }, {
        label: 'Split Details',
        value: getProductSplitDetails(props.product),
      },
    ].filter((a) => a.value));

    watch(countryCode, async () => {
      country.value = await searchCountry({ id: countryCode.value });
    }, { immediate: true });

    return {
      lastOpenedTabId,
      resetLastOpenedTabId,
      attributes,
      country,
    };
  },
});
